import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onPrint?: () => void;
  onSearch?: () => void;
  onRefresh?: () => void;
  isEditDisabled?: boolean;
  className?: string;
}

export default function ActionBar({
  className,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onPrint,
  onSearch,
  onRefresh,
  isEditDisabled = true
}: ActionBarProps) {
  return (
    <ActionBarV2 title='Chứng từ phải thu khác, chứng từ bù trừ công nợ' className={className}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} disabled={isEditDisabled} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopy} disabled={isEditDisabled} />
      <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrint} />
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearch} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 1
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {},
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => {},
            group: 3
          }
        ]}
      />
    </ActionBarV2>
  );
}
